import React from 'react'

function ProductCardSkeleton() {
    return (
        <div className="space-y-4">
            <div className="relative aspect-3/4 w-full bg-muted-color rounded-2xl animate-pulse" />
            <div className="space-y-2">
                <div className="flex justify-between gap-4">
                    <div className="h-4 w-2/5 bg-muted-color rounded animate-pulse" />
                    <div className="space-y-1.5 text-end">
                        <div className="h-3 w-16 bg-muted-color rounded animate-pulse ml-auto" />
                        <div className="h-3 w-12 bg-muted-color rounded animate-pulse ml-auto" />
                    </div>
                </div>
                <div className="flex items-center justify-between gap-4">
                    <div className="h-3 w-28 bg-muted-color rounded animate-pulse" />
                    <div className="h-6 w-24 bg-muted-color rounded-sm animate-pulse" />
                </div>
            </div>
        </div>
    )
}

export default function CategoryProductSkeleton({ count = 6 }: { count?: number }) {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
            {Array.from({ length: count }).map((_, i) => (
                <ProductCardSkeleton key={i} />
            ))}
        </div>
    )
}
